import { FunctionComponent, useState, useEffect } from "react";
import rakete_bg from "../../assets/svg/raketebg.svg";
import rakete_bg_mobile from "../../assets/svg/raketebg_mobile.svg";
import { useTranslation } from "../../TranslationContext";

const Hero: FunctionComponent = () => {
  const translations = useTranslation();
  const [isLgOrBelow, setIsLgOrBelow] = useState(window.innerWidth <= 1023);

  useEffect(() => {
    const handleResize = () => {
      setIsLgOrBelow(window.innerWidth <= 1023);
    };

    window.addEventListener('resize', handleResize);
    
    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div
      id="hero"
      className="relative w-full overflow-hidden flex flex-col box-border items-center justify-center text-left text-5xl text-nebula-950 font-text-xl-font-normal xl:text-4xl lg:text-3xl xxs:text-2xl lg:leading-tight bg-white-to-black-gradient lg:bg-white-to-white-gradient"
    >
      <div className="w-full flex flex-row items-center justify-center lg:flex-col md:gap-0 max-w-[1340px] ">
        <div className="flex-1 flex flex-col items-start justify-center max-w-[45%] lg:max-w-[100%] lg:flex pl-16 lg:px-16 md:px-6">
          <div className="self-stretch flex flex-col items-start justify-start gap-[24px] lg:py-8">
            <div className="self-stretch flex flex-col items-start justify-start">
              <div className="self-stretch relative leading-[125%] font-extrabold">
                <h1>{translations.hero.header1}</h1>
              </div>
              <div className="self-stretch relative leading-[125%] font-extrabold text-gradient-dark">
                <h1>{translations.hero.header2}</h1>
              </div>
            </div>
            <div className="self-stretch relative text-xl leading-[150%] text-slate-800">
              <h2 className="text-xl leading-[150%] text-slate-800 sm:text-base">
                {translations.hero.description}
              </h2>
            </div>
          </div>
        </div>
        <div className="self-stretch flex-1 flex flex-col items-end justify-end h-full w-full max-w-[716px] bg-white ml-auto" style={{ height: '100%' }}>
          <img
            src={isLgOrBelow ? rakete_bg_mobile : rakete_bg}
            alt={translations.hero.imageAlt}
            className="self-stretch"
          />
        </div>
      </div>
    </div>
  );
};

export default Hero;